export const APPROVAL_HOLD_MESSAGE =
  'Submitted for approval. A second admin needs to approve this in Settings → Approvals.';

export const isApprovalHold = (data: { approvalRequired?: boolean }) =>
  data?.approvalRequired === true;
